export default __webpack_public_path__ + "static/media/cta-proprietari.8a33f3e9.jpg";